import React, { useEffect } from 'react';
import SearchBar from '../explore/searchBar/searchBar';
import {ContactItem} from '../explore/contacts/contact';
import {EntityItem} from "../explore/entities/entities";

function SearchCarto({dataListContacts,dataListEntities,handleFocus}){

    const [filterDisplay, setFilterDisplay] = React.useState([]);
    const [open, setOpen] = React.useState("");
    const [search, setSearch] = React.useState("");

    useEffect(() => {
        setSearch(search);
        let oldContactList = dataListContacts;
        let oldEntitiesList = dataListEntities;

        if(search !== ""){
            const search_ = parseAccent(search).toUpperCase();
            setOpen("open");
            const newContactList = oldContactList.filter(c =>
                parseAccent(c.firstname).toUpperCase().includes(search_) ||
                parseAccent(c.lastname).toUpperCase().includes(search_) ||
                ""
            );

            const newEntitiesList = oldEntitiesList.filter(e=>
                parseAccent(e.name).toUpperCase().includes(search_) ||
                parseAccent(e.alias).toUpperCase().includes(search_) ||
                "");
            const newList = sortList(newContactList.concat(newEntitiesList));
            setFilterDisplay(newList);
        }else{
            setOpen("");
            setFilterDisplay(sortList(dataListContacts.concat(dataListEntities)));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    function parseAccent(e){
        if(e !== "" && e!== null){
            return e.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        }
        return "";
    }
    const onClickSearch = (id,type) => {
        handleFocus(id,type);
        setSearch("");
    }
    const LinkFactory = ({id,type,children}) => {

        return <div onClick={()=>{onClickSearch(id,type)}}
                    key={id} type={type}>
            { children }
        </div>
    }

    const displayList = (list) =>{
        return list.map((i)=>{
            if(!i.firstname){
                return <EntityItem key={"e"+i.id} entity={i} LinkFactory={LinkFactory} />;
            }else{
                return <ContactItem key={"c"+i.id} contact={i} LinkFactory={LinkFactory} />;
            }
        })
    }

    function sortList(data) {
        return data.sort(function (a, b) {
            const nameA = a.lastname ? a.lastname : a.name;
            const nameB = b.lastname ? b.lastname : b.name;
            return parseAccent(nameA).toUpperCase().localeCompare(parseAccent(nameB).toUpperCase());
        });
    }

    function clearSearch(){
        setSearch('');
    }

    const handleChange = event => {
        setSearch(event);
    }

    return (
        <>
            <div className="c-container_search-bar">
                <SearchBar value={search} handleChange={e => handleChange(e.target.value)}/>
                {search.length>0 && <div onClick={clearSearch} className="cross_search"></div>}
            </div>
            <div className={"c-container_infos main-data " + open}>
                {displayList(filterDisplay)}
            </div>
        </>
    );

}

export default SearchCarto;
